import React, { useEffect, useState } from "react";
import "./header.css";
import Slider from "react-slick";
import { api, s3Url } from "../../service/api.service";

export default function Header() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch(
          `${api.defaults.baseURL}admin/banner/all`,
          {
            headers: {
              Accept: "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const json = await response.json();

        setBanners(
          (json.data || []).filter((banner) => banner.isDeleted !== true)
        );
      } catch (error) {
        console.error("Failed to fetch banners:", error);
        setBanners([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  var setting = {
    dots: true,
    arrows: false,
    infinite: banners.length > 1,
    speed: 500,
    autoplay: banners.length > 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    cssEase: "linear",
  };

  return (
    <>
      <div className="header-section pt-40 relative overflow-hidden mb-20 hero-slider">
        <div className="max-w-7xl mx-auto px-4">
          <div className="relative">
            {loading ? (
              <div className="hero-slider-placeholder w-full h-64" />
            ) : banners.length > 0 ? (
              <Slider {...setting}>
                {banners.map((banner) => (
                  <div key={banner._id}>
                    <img
                      src={`${s3Url}${banner.imageUrl}`}
                      alt={banner.title || "Banner"}
                      className="w-full h-auto object-cover"
                      loading="lazy"
                    />
                  </div>
                ))}
              </Slider>
            ) : null}
            <img
              src="/assets/hero-shape.svg"
              className="left-shape absolute -left-12 top-20"
              alt="leftshape"
            />
            <img
              src="/assets/hero-shape.svg"
              className="right-shape absolute -right-12 bottom-24"
              alt="rightshape"
            />
          </div>
        </div>
        <img
          src="/assets/left-line.svg"
          className="absolute left-0 top-24"
          alt="leftline"
        />
        <img
          src="/assets/right-line.svg"
          className="absolute right-0 top-24"
          alt="rightline"
        />
      </div>
    </>
  );
}